var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4577 5.92135C15.6872 3.8335 14.0768 2 11.9999 2C9.92306 2 8.31263 3.83344 8.54205 5.92124C6.87529 4.67567 4.50565 5.17447 3.46723 6.99994C2.42878 8.82548 3.18807 11.1578 5.08439 12C3.18809 12.8422 2.42881 15.1745 3.46726 17C4.50567 18.8255 6.8753 19.3243 8.54205 18.0787C8.31262 20.1665 9.92305 22 11.9999 22C14.0768 22 15.6872 20.1665 15.4577 18.0786C17.1245 19.3243 19.4942 18.8256 20.5327 17C21.5711 15.1745 20.8118 12.8421 18.9155 12C20.8119 11.1579 21.5712 8.82546 20.5328 6.99989C19.4943 5.17433 17.1245 4.67557 15.4577 5.92135ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerAlt1);
export default __webpack_public_path__ + "static/media/flower-alt-1.f6e42e4b6d4a9fbc4da33ca03286f17e.svg";
export { ForwardRef as ReactComponent };